/**
 * @class
 */
import Base from './assetConstituents_';
import Model from '../models/assetConstituent_page';

export default class AssetConstituents_Pages extends Base {
	/** @type {string} */
	get type() {
		return 'pages';
	}

	/**
	 * @property {object}  methods       - Collection RPC methods
	 * @property {method}  methods.read  - Search pages
	 */
	get methods() {
		return _.extend(super.methods, {
			/**
			 * @method
			 * @param {string} str Search fragment
			 * @param {object} opts Request options
			 */
			searchPDFPages(str, opts) {
				this.filtered = true;
				return ['searchPDFPages', this.assetId, str];
			},
		});
	}

	/*
	 * @property {object}   parsers                 - Collection parsers
	 * @property {function} parsers.read            - Parse the results of fetch
	 * @property {function} parsers.searchPDFPages  - Parse the results of search
	 */
	get parsers() {
		return _.extend(super.parsers, {
			/**
			 * @function
			 * @param {array} data Data
			 * @param {object} opts Request options
			 */
			read(data, opts) {
				// Set page number - cannot be certain of this with the ref/id
				_.each(data.pages, (page, idx) => {
					page.pageNumber = idx + 1;
				});
				this.originalPages = data.pages.slice();
				return data.pages;
			},
			/**
			 * @function
			 * @param {array} data Data
			 * @param {object} opts Request options
			 */
			searchPDFPages(data, opts) {
				this.reset(
					_.map(data, (d, idx) => {
						d.pageNumber = idx + 1;
						return d;
					}),
				);
			},
		});
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);

		/**
		 * Store original pages (for search results)
		 * @memberOf Netx.Collections.Pages
		 * @alias originalPages
		 * @type {array}
		 */
		this.originalPages = this.originalPages || [];
	}

	/**
	 * Clear search
	 * @method
	 */
	clearSearch() {
		// No longer filtered
		this.filtered = false;
		this.reset(this.originalPages);
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituents_Pages';
	}
}
